import controller from './response.controller';
import template from './template/response.view.html';
import templateAD from './template/response.adaptative.view.html';

let ResponseComponent = {
  template:changeTemplate,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

function changeTemplate() {
    if(__env.adaptative){
      return templateAD;
    } else {
      return template;
    }
  }

export default ResponseComponent;



/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/response/response.component.js
 **/